import React, { ReactElement, ReactNode } from "react";
import helper from "../helper/helper";

export interface AuthorizationProps {
  children: ReactElement;
  roles: string[];
}

function Authorization(props: AuthorizationProps) {
  let roles: string[] = helper.getRoles();

  if (roles == null) {
    return <></>;
  }

  let exists = false;

  for (const role of roles) {
    if (props.roles.includes(role)) {
      exists = true;
      break;
    }
  }

  if (exists) {
    return props.children;
  } else {
    return <></>;
  }
}

export default Authorization;
